/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Service that sends the element ref from a scroll event
 *
 * @export
 * @class ScrollListenerService
 */
@Injectable(
  { providedIn: 'root' }
)
export class ScrollListenerService {
  /**
   * Stream of element refs
   *
   * @private
   * @type {Subject<ElementRef>}
   * @memberof ScrollListenerService
   */
  private scrollEvent: Subject<ElementRef>;
  /**
   * stores container for infinite scroll
   * @type ElementRef
   */
  public infiniteScrollContainer: Element;

  /**
   * Creates an instance of ScrollListenerService.
   * @memberof ScrollListenerService
   */
  constructor() {
    this.scrollEvent = new Subject<ElementRef>();
  }

  /**
   * Set the next stream value for element ref subject
   *
   * @param {ElementRef} el
   * @memberof ScrollListenerService
   */
  public nextScrollEvent(el: ElementRef): void {
    this.scrollEvent.next(el);
  }
  /**
   * sets the container for infinite scroll
   * @param ElementRef
   * @returns void
   */
  public setInfiniteScroll(scrollableContainer: Element): void {
    this.infiniteScrollContainer = scrollableContainer;
  }
  /**
   * gets the container for infinite scroll
   * @returns ElementRef
   */
  public getInfiniteScroll(): Element {
    return this.infiniteScrollContainer;
  }

  /**
   * Return the observable stream of subject
   *
   * @returns {Observable<ElementRef>}
   * @memberof ScrollListenerService
   */
  public getScrollEvent(): Observable<ElementRef> {
    return this.scrollEvent.asObservable();
  }
}
